// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b2a4d73b","158":"b3a215ce","858":"08cc2326"}[chunkId] + ".chunk.js";
};